// extracted by mini-css-extract-plugin
export var fileExt = "_v7-8";
export var fileIcon = "_v7-6";
export var fileLink = "_v7-5";
export var fileName = "_v7-7";
export var image = "_v7-1";
export var imageError = "_v7-3";
export var imageErrorIcon = "_v7-4";
export var imageLink = "_v7-0";
export var imageLoaded = "_v7-2";